import { render } from "./BotFrameworkChat.vue?vue&type=template&id=a036d448&scoped=true&ts=true"
import script from "./BotFrameworkChat.vue?vue&type=script&lang=ts"
export * from "./BotFrameworkChat.vue?vue&type=script&lang=ts"

import "./BotFrameworkChat.vue?vue&type=style&index=0&id=a036d448&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a036d448"]])

export default __exports__